/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';
import { TAgent, getAgent } from './agent';

const is = require('is_js');

const SERVICE_NAME = 'PaymentPageService';

@injectable()
export class PaymentPageService {
  public agent: TAgent;
  static displayName = 'PaymentPageService';
  constructor(props: any = {}) {
    this.agent = getAgent();
  }
}
